import React from 'react';

const CustomRowText = ({
    title,
    value,
    titleColor = 'text-[#9FAFA4]',
    valueColor = 'text-[#9FAFA4]',
    fontSize = 14,
    needBorders = false
}) => {
    return (
        <div className={`flex flex-row ${needBorders ? 'border border-black' : ''}`}>
            <div
                className={`p-2 ${titleColor} font-bold`}
                style={{ fontSize: `${fontSize}px` }}
            >
                {title}
            </div>
            <div
                className={`flex-1 p-2 ${valueColor}`}
                style={{ fontSize: `${fontSize}px` }}
            >
                {value}
            </div>
        </div>
    );
};

export default CustomRowText;